import { render, staticRenderFns } from "./SelectMultipleCustomers.vue?vue&type=template&id=3d25002c&"
import script from "./SelectMultipleCustomers.vue?vue&type=script&lang=ts&"
export * from "./SelectMultipleCustomers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports